import styled, { keyframes } from 'styled-components';
import { createGradientOrSolid } from '../Helper/utils/utils';

const showModal = keyframes`
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const hideModal = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const StyledModalBorder = styled.div`
    animation: ${showModal} 0.6s forwards;
    opacity: 0;
    max-width: 400px;
    width: 90%;
    max-height: 90%;
    overflow-y: auto;
    padding: 5px;
    border-radius: 30px;
    background: ${(props: any) => createGradientOrSolid(props.colors)};

    &.fadeout {
        animation: ${hideModal} 0.3s forwards;
    }
` as any;

export const StyledModal = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    padding-top: 60px;
    border-radius: 24px;
    background: ${(props: any) => createGradientOrSolid(props.colors)};
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: ${(props: any) => props.fontFamily};

    .closeButton {
        position: absolute;
        cursor: pointer;
        top: 20px;
        right: 15px;
        height: 32px;
    }

    h2 {
        margin: 0;
        margin-bottom: 16px;
        font-size: ${(props: any) => `${props.headerFontSize}px`};
        font-weight: ${(props: any) => props.titleWeight && props.titleWeight};
        text-align: center;
        background: ${(props: any) =>
            createGradientOrSolid(props.headerColors)};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    h5 {
        margin-top: 0;
        margin-bottom: 20px;
        text-align: center;
    }

    button {
        height: 60px;
        width: 100%;
        cursor: pointer;
    }
` as any;
